import { Component } from '@angular/core';
import { IconDefinition, faHourglassStart } from '@fortawesome/pro-solid-svg-icons';
import { Store } from '@ngxs/store';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';

@Component({
   selector: 'samweb-waiting-item',
   templateUrl: './waiting-item.component.html',
   styleUrls: ['./waiting-item.component.scss'],
})
export class WaitingItemComponent extends Toast {
   constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, public store: Store) {
      super(toastrService, toastPackage);
   }

   public phoneIcon: IconDefinition = WellKnownIconsEnum.CALLING_ANSWER.icon;
   public hourGlassIcon: IconDefinition = faHourglassStart;
}
